import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { mapEmplyeeCourses } from '../../reducers/coursesReducer';
import { fetchEmployeeMasterCoursesIfNeeded, fetchEmployeeMasterCourses } from '../../actions/courses';
import EditPanel from './EditPanel';

const EmployeeMasterCourses = ({
  employeeMasterCoursesData,
  showErrorMessage,
  errorMessage,
  loaded,
  EmployeeMasterID,
  dispatch,
}) =>
  (<EditPanel
    title={<FormattedMessage id="course.title" />}
    emptyText="course.empty"
    loaded={loaded}
    showErrorMessage={showErrorMessage}
    errorMessage={errorMessage}
    onOpen={() => dispatch(fetchEmployeeMasterCoursesIfNeeded())}
    modelName="EmployeeMasterCourse"
    dataSource={employeeMasterCoursesData}
    mapModel={mapEmplyeeCourses}
    EmployeeMasterID={EmployeeMasterID}
    fetchData={fetchEmployeeMasterCourses}
    initSort="CoursePeriodBegda"
  />);

function mapStateToProps(state) {
  return {
    loaded: state.coursesReducer.employeeMasterCoursesLoaded,
    employeeMasterCoursesData: state.coursesReducer.employeeMasterCoursesData,
    form: state.form.EmployeeMasterCourse,
    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
    showErrorMessage: ((state.coursesReducer.employeeMasterCoursesError && state.coursesReducer.employeeMasterCourseserror.Message.length) > 0),
    errorMessage: (state.educationReducer.error && state.educationReducer.error.Message) || '',
  };
}

EmployeeMasterCourses.propTypes = {
  loaded: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  showErrorMessage: PropTypes.bool,
  errorMessage: PropTypes.string,
  EmployeeMasterID: PropTypes.number,
  employeeMasterCoursesData: PropTypes.array,
};

export default connect(mapStateToProps)(EmployeeMasterCourses);



// WEBPACK FOOTER //
// ./src/components/profile/EmployeeMasterCourses.js